import {atom} from 'jotai';

/**
 * keycloak에서 발급받은 토큰을 저장
 */
export const tokenAtom = atom<string | null>(null);
